// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"177":"home","335":"api","596":"404","867":"douyin-code-page"}[chunkId] || chunkId) + "." + {"177":"ebe459c9","335":"fb1c8fc1","596":"ccb36ccb","680":"b389e3fb","867":"37d2d88d"}[chunkId] + ".js";
};